import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { ModuleIsEnabledFilter } from '@gongxigames/framework/core';
import {
    GameSessionPromotionStatesMap,
    GameSessionPromotionStates,
    BasePromotionModule,
    PromotionTypes,
    isEnabledPromotionType,
    CounterData
} from '@gongxigames/framework/promotions';

export type GameSessionPromotionEvents = {
    'GameSessionPromotion.START_STATE_LEFT': void;
} & GlobalEventsMapForBackwardCompatibility;

export class GameSessionPromotionModule extends BasePromotionModule<GameSessionPromotionEvents> {
    public static readonly NAME: symbol = Symbol.for('GameSessionPromotionModule');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledPromotionType(PromotionTypes.GameSessionPromotion);

    public setupStates(): void {
        this.addStates(GameSessionPromotionStatesMap);
        this.gotoState(GameSessionPromotionStates.INIT);
    }

    protected getCounterData(): CounterData {
        const { left, total, id, type } = this.getPromotion().getData();

        return { left, total, id, type };
    }
}
